<template>
    <div :class="[themeClass,...oauthClass,'lnk-table-datapanel','table-panel']">
        <div class="data-panel">
            <div  v-if="title || conf.title" class="data-panel-title">
                <el-row>
                    <div class="vbar"></div>
                    <span>{{title || conf.title}}</span>
                </el-row>
            </div>
            <slot></slot>
            <quickfilter v-if="!islocal"></quickfilter>
            <div v-loading="loading"
                 :class="{'is-loading':loading}"
                 :element-loading-text="$t('LnkTableDatapanel.hintLoading')"
                 element-loading-background="rgba(0, 0, 0, 0)"
                 element-loading-spinner="el-icon-loading">
                <el-row ref="tabletools" style="position: initial;" class="tools">
                    <div v-if="$slots.tools || !toolsShow">
                        <slot name="tools"></slot>
                    </div>
                    <div v-else>
                        <slot name="select-pre"></slot>
                        <selectunit></selectunit>
                        <div class="tools-right">
                            <slot name="tools-right"></slot>
                            <el-dropdown v-if="buttonMore" trigger="click" size="small" class="menu-more">
                                <el-button class="blue w2">
                                    <span>{{$t('LnkTableDatapanel.menuMore')}}</span><i class="iconfont icon-xiala"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <slot name="dropdown-item"></slot>
                                    <el-dropdown-item v-if="!islocal && top.importFlag==='Y' && buttonImport" command="importData">{{$t('LnkTableDatapanel.menuImport')}}</el-dropdown-item>
                                    <el-dropdown-item v-if="!islocal && top.exportFlag==='Y' && buttonExport" command="exportData">{{$t('LnkTableDatapanel.menuExport')}}</el-dropdown-item>
                                    <el-dropdown-item v-if="!islocal" command="combfilter">{{$t('LnkTableDatapanel.menuMultiSearch')}}</el-dropdown-item>
                                    <el-dropdown-item command="detail">{{$t('LnkTableDatapanel.menuRecordDetail')}}</el-dropdown-item>
                                    <el-dropdown-item command="count">{{$t('LnkTableDatapanel.menuRecordTotal')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </el-row>
                <div :class="{'isshow-in-duty':showduty,'hide-frame-border':hideFrameBorder}">
                    <el-row ref="tablerows" class="rows" :class="{'in-duty':!!$scopedSlots.table}" style="position: initial;">
                        <slot name="table"
                              :props="tableProps"
                              :data="rows"
                              :height="tableHeight"
                              :showdel="showDel"
                              :showedit="showEdit"
                              :editable="editAble"
                              :delable="delAble"
                              :main="mainRow.id"
                              :fresh="fresh"
                              :setmain="submitPropmain"></slot>
                    </el-row>
                </div>
                <div class="pager" v-if="pagerShow">
                    <pagination v-show="pagerAutohide?total>pageSize:true"
                                @request-total="toggleForceTotalflag"
                                @empty-page="setPage"
                                :page="page"
                                :data="rows"
                                :rows="pageSize || 0"
                                :total="total"
                                :custom-layout="pagerLayout"
                                :totalFlag="islocal?true:(isTotalForceFetched || totalFlag)"
                                :page-sizes="pagerSizes"
                                @size-change="setPgSize"
                                @current-change="setPage">
                    </pagination>
                </div>
            </div>
        </div>
        <el-row ref="dlgedit" class="table-dialog">
            <slot name="edit"
                  :loading="isSaving"
                  :props="editDlgProps"
                  :show="editShow"
                  :mode="editMode"
                  :row="editFmDt"
                  :is-update="editMode"
                  :rules="conf.rules?conf.rules:{}"></slot>
        </el-row>
        <combfilter :show.sync="combfilterShow"></combfilter>
        <exportconf
            :data="fields"
            :exportDialog.sync="exportShow"
            @submit-success="handleExport"></exportconf>
    </div>
</template>

<script>
/**
     说明文档路径：

     http://link-crm.com/web/portal/knowledge/dialog/knowledgeReadOnly.html?id=W-318D604&openOrgin=true&_SecurityMenuId=W-9IXSQ

     @name: lnk-table-datapanel 表格组件
     @createdby:HuangJian
     @props:

     conf:Object,配置信息
     oauth:String,安全性配置
     theme:String, 主题
     title:String,块标题
     autofresh:Boolean,参数变化时自动刷新列表,default:true
     optfresh:Boolean,新建编辑删除 时强制刷新列表,default:false
     currentrow:Object,当前行
     query-para:Object, 查询参数入口
     insert-para:Object,新建参数入口
     update-para:Object,更新参数入口
     upsert-para:Object,新建更新 参数入口
     upmain-para:Object,设置主要行 参数入口
     main-relateid:String,主要行 关联id
     data:Array,表格行数据
     pg-sizes:Array,分页条数可选项,default:[5,20,50,100]
     pager-layout:type:String,分页样 default:'sizes,prev,next,pager,jumper',
     pager-autohide:Boolean,分页自动隐藏 default:true
     islocal:Boolean,是否禁用接口交互,default:false
     local-filter:Boolean,禁用接口交互时，是否禁用本地的筛选功能，default:true,
     mainid:type:String,主要行的id,default:null
     tools-show:Boolean,是否启用自带工具栏,default:true
     pager-show:Boolean,是否启用分页栏,default:true
     before-query:Function,查询前钩子函数
     after-query:Function,查询后的钩子函数
     before-upsert:Function,插入更新前的钩子函数
     after-upsert:Function,插入更新后的钩子函数
     before-upmain:Function,更新主要行前的钩子函数
     before-edit:Function,打开编辑框前的钩子函数
     before-del:Function,删除前的钩子函数
     before-clear:Function,清空列表时的钩子函数（islocal为false时有效）
     click-monitor:Boolean,自动监听组件里 新建/确定/取消 按钮的 click事件,default:false
     sort-all:打开所有字段的排序功能，default:false
     */

import pagination from '../lnk-pagination-v';
import selectunit from '../lnk-table-selectfilter';
import tablecore from './tablecore';
import combfilter from '../lnk-combinefilter';
import exportconf from '../lnk-export-pick';
import quickfilter from '../lnk-quickfilter';
import themeClass from '@mixins/theme-class';
import heightControl from '@mixins/height-control';
export default {
    name: 'lnk-table-datapanel',
    components: {pagination, selectunit, combfilter, exportconf, quickfilter},
    mixins: [tablecore, themeClass, heightControl],
    computed: {
        oauthClass(){
            var rslt = [];
            const ref = {
                addFlag: {Y: 'add-on', N: 'add-off'},
                deleteFlag: {Y: 'del-on', N: 'del-off'},
                editFlag: {Y: 'edit-on', N: 'edit-off'},
                readonlyFlag: {Y: 'readonly-on', N: 'readonly-off'}
            };
            for(var key in ref){
                var val = ref[key][top[key]];
                if(val){
                    rslt.push(val);
                }
            }
            if(this.parentField){
                if(!this.getParentId()){
                    rslt.push('no-parent');
                }
            }
            return rslt;
        },
        editAble(){
            var rslt = true;
            if(this.parentField){
                if(!this.getParentId()){
                    rslt = false;
                }
            }
            if(window.CURRENT_ORIGIN_TOP.editFlag !=='Y'){
                rslt = false;
            }
            return rslt;
        },
        delAble(){
            var rslt = true;
            if(this.parentField){
                if(!this.getParentId()){
                    rslt = false;
                }
            }
            if(window.CURRENT_ORIGIN_TOP.deleteFlag !=='Y'){
                rslt = false;
            }
            return rslt;
        }
    },
    data(){
        return{
            /* 编辑弹框的附加属性*/
            editDlgProps: {
                appendToBody: true,
                showClose: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                class: ['lnk-table-datapanel-dlg', 'rowedit']
            }
        };
    }
};
</script>

<style lang="scss">
    $crm-color:#1F74FF;
    $dms-color:#409EFF;

    .add-off.table-panel.lnk-table-datapanel{
        .shownew,.add-btn{
            display: none;
        }
    }
    .edit-off.table-panel.lnk-table-datapanel{
        .showedit,.edit-btn{
            display: none;
        }
    }
    .del-off.table-panel.lnk-table-datapanel{
        .showdel,.del-btn{
            display: none;
        }
    }
    .no-parent.table-panel.lnk-table-datapanel,
    .readonly-on.table-panel.lnk-table-datapanel{
        .showedit,.edit-btn,.showdel,.del-btn,.shownew,.add-btn{
            display: none;
        }
    }
    .table-panel.lnk-table-datapanel+
    .table-panel.lnk-table-datapanel{
        margin-top: 16px;
    }
    .table-panel.lnk-table-datapanel{
        .lnk-quickfilter.in-duty+div{
            margin-top: 16px;
        }
        .data-panel-title{
            line-height: 14px;
            height: 14px;
            margin-bottom: 16px;
            margin-left: 2px;
            position: relative;
            letter-spacing: 1px;
        }
        .data-panel-title .vbar{
            display: inline-block;
            width: 3px;
            height: 14px;
            background: $crm-color;
            vertical-align: -2px;
            margin-right: -4px;
        }
        .data-panel-title span{
            font-size: 14px;
            font-weight: 600;
            padding-left: 8px;
            display: inline-block;
            color: #22252a;
    }
        .el-button{
            padding: 0;
            margin: 0;
            border-radius: 0;
            font-size: 12px;
        }
        .el-button.blue{
            background:  $crm-color!important;
            border-color: $crm-color!important;
            color: #FFFFFF!important;
        }
        .el-button.light{
            background: #ffffff!important;
            border-color: $crm-color!important;
            color: $crm-color!important;
        }
        .tools {
            .clearfix:before,
            .clearfix:after {
                content: " ";
                display: table;
            }
            .tools-right{
                float: right;
            }
            .el-button{
                height: 28px;
            }
            .el-button.blue,
            .el-button.light{
                margin-left: 12px;
            }
            .menu-more.el-dropdown{
                float: right;
            }
            .el-button{
                min-width: 72px;
                padding: 0 8px;
            }
            .el-scrollbar__view.el-select-dropdown__list{
                max-height: 162px;
            }
            .el-dropdown .el-button{
                width: 68px;
                height: 28px;
            }
        }
        /*为满足需求临时加的*/
        .isshow-in-duty{
            .rows.in-duty{
                margin-top: 0;
                border: 0;
            }
        }
        /*为满足需求临时加的*/
        .hide-frame-border{
            .rows.in-duty{
                margin-top: 0;
                border: 0;
            }
        }
        .is-loading{
            .el-table__empty-text{
                display: none!important;
            }
        }
        .rows.in-duty{
            margin-top: 12px;
        }
        .pager .el-row{
            margin-top: 12px;
        }
    }
    .table-panel.lnk-table-datapanel.dms-color{
        .data-panel-title .vbar{
            background: $dms-color;
        }
        .el-button.blue{
            background:  $dms-color!important;
            border-color: $dms-color!important;
            color: #FFFFFF!important;
        }
        .el-button.light{
            background: #ffffff!important;
            border-color: $dms-color!important;
            color: $dms-color!important;
        }
        .rows .el-table {
            .el-table__row {
                td {
                    .cell {
                        .split, .with-division {
                            background: $dms-color;
                        }
                        .el-button.el-button--text {
                            font-weight: 600;
                            font-size: 12px;
                            color: $dms-color;
                        }
                    }
                }
            }
        }
    }
    .lnk-table-datapanel-dlg{
        .el-button.blue{
            background:  $crm-color!important;
            border-color: $crm-color!important;
            color: #FFFFFF!important;
        }
        .el-button.light{
            background: #ffffff!important;
            border-color: $crm-color!important;
            color: $crm-color!important;
        }
        .el-dialog__body{
            padding: 16px;
            background: #F6F7FB;
        }
        .table-dialog-info{
            padding:16px;
        }
        .el-dialog__footer{
            text-align: center;
        }
        .el-dialog__footer .el-button{
            width: 68px;
            height: 28px;
            margin-left: 12px;
            padding: 0;
            line-height: 28px;
        }
    }
    .lnk-table-datapanel-dlg.dms-color{
        .el-button.blue{
            background:  $dms-color!important;
            border-color: $dms-color!important;
            color: #FFFFFF!important;
        }
        .el-button.light{
            background: #ffffff!important;
            border-color: $dms-color!important;
            color: $dms-color!important;
        }
    }
    .lnk-table-datapanel-dlg.message{
        .el-dialog{
            width: 304px;
        }
        .el-dialog__body{
            min-height: 86px;
        }
    }
    .lnk-table-datapanel-dlg.rowedit {
        .el-dialog{
            width: 504px;
            margin-top:60px!important;
        }
        .el-form{
            .innerbox{
                width: 280px;
            }
            .innerbox .el-textarea__inner{
                margin-bottom: 16px;
            }
            .el-button{
                padding: 0;
                margin: 0;
            }
            .inputhint{
                color: #384250;
                padding-left: 16px;
            }
            .el-form-item__error{
                font-size: 12px;
                padding: 2px 0;
            }
            .el-radio__label{
                padding-left: 5px;
                font-size: 12px;
            }
            .el-checkbox__label{
                font-size: 12px;
                line-height: 12px;
            }
            .el-form-item{
                margin: 0;
                padding: 0;
            }
            .el-input-group__append{
                padding: 0 7px;
                border-radius: 0;
            }
            .withprefix .el-input__prefix{
                left: 10px;
            }
            .el-input-group__append button.el-button{
                border-color: transparent!important;
                background-color: transparent!important;
            }
            .el-form-item__label{
                color: #384250;
                font-weight: 600;
                font-size: 12px;
                padding-right: 24px;
                line-height: 28px;
                width: 120px;
            }
            .el-checkbox__label{
                font-size: 12px;
            }
            .inputbox{
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 16px;
            }
            .rediobox{
                margin-bottom: 16px;
            }
            .rediobox_nogap{
                margin-bottom: 16px;
            }
            .rediobox .redio-items{
                width: 280px;
            }
            .rediobox_nogap .redio-items{
                display: table;
            }
            .redio-item{
                width: 106px;
                float: left;
            }
            .redio-item.row2{
                width: 160px;
            }
            .rediobox .gap{
                margin-top: 15px;
            }
            .el-input.is-disabled .el-input-group__prepend span{
                color: #858E96;
            }
            .el-range-editor.is-disabled input{
                color: #858E96;
            }
            .panel-form-textinfo span{
                font-size: 12px;
                float: left;
                color: #384250;
            }
            .panel-form-textinfo.right{
                float: right;
            }
            .rediobox  .el-form-item__label,
            .rediobox_nogap  .el-form-item__label{
                line-height: 16px;
            }
            .rediobox .el-form-item__content,
            .rediobox_nogap .el-form-item__content{
                line-height: 16px;
            }
            .inputbox .el-form-item__content {
                line-height: 28px;
            }
            .textbox{
                margin-bottom: 16px;
            }
            .el-input__inner {
                font-size: 12px;
                line-height: 28px!important;
                height: 28px!important;
                border-radius: 0;
                color: #384250;
            }
            .el-date-editor i,
            .el-date-editor .el-range-separator{
                color: #384250;
            }
            .doual-fmitem .el-form-item{
                float: left;
            }
            .el-input-group>.el-input__inner{
                display: initial;
            }
            .panel-form-textinfo span{
                font-size: 12px;
            }
            .panel-form-imginfo{
                width: 280px;
            }
            .panel-form-imginfo img{
                width: 280px;
                height: 280px;
            }
            .el-cascader{
                line-height: 28px;
            }
            .el-cascader__label{
                font-size: 12px;
            }
            .el-textarea__inner{
                font-size: 12px;
            }
            .el-date-editor.innerbox i{
                line-height:28px;
                height: 28px;
                font-size: 12px;
            }
            .el-date-editor.innerbox .el-range-input{
                font-size: 12px;
            }
            .el-date-editor.innerbox span{
                line-height:28px;
                height: 28px;
                font-size: 12px;}

            .el-textarea__inner{
                border-radius: 0;
            }
            .panel-form-btn .el-button{
                height: 28px;
                width: 100px;
            }
            .el-button span{
                font-size: 12px;
            }
        }
    }


</style>
